import React, { useEffect, useState } from "react";
import { Plus, Trash2, PhoneCall } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

const TYPES = ["Functional Support", "Technical Support", "Training Support"];

export default function AdminEscalations({ refs, canEdit = true }) {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ program_id: "", type: "Functional Support", name: "", email: "", sla: "", note: "" });

  const load = () => api.get("/escalations").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const create = async () => {
    try { await api.post("/escalations", form); toast.success("Contact added"); setOpen(false); setForm({ program_id: "", type: "Functional Support", name: "", email: "", sla: "", note: "" }); load(); }
    catch { toast.error("Failed"); }
  };
  const remove = async (e) => { await api.delete(`/escalations/${e.id}`); toast.success("Removed"); load(); };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <p className="text-sm text-slate-500">{items.length} escalation contacts</p>
        {canEdit && <Button onClick={() => setOpen(true)} data-testid="admin-create-escalation"><Plus className="w-4 h-4 mr-1.5" /> New Contact</Button>}
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="admin-escalations-grid">
        {items.map((e) => (
          <div key={e.id} className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="flex items-start justify-between">
              <span className="text-xs rounded-full bg-slate-100 px-2 py-0.5 text-slate-500">{refs.programName(e.program_id)}</span>
              {canEdit && <Button size="icon" variant="ghost" className="text-rose-500 h-7 w-7" onClick={() => remove(e)} data-testid={`delete-escalation-${e.id}`}><Trash2 className="w-4 h-4" /></Button>}
            </div>
            <p className="text-sm font-semibold text-slate-800 mt-2">{e.type}</p>
            <p className="text-sm text-slate-600">{e.name}</p>
            <p className="text-xs text-primary break-all">{e.email}</p>
            <p className="text-xs text-slate-400 mt-1">SLA {e.sla}</p>
          </div>
        ))}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>New Escalation Contact</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div>
              <Label>Program</Label>
              <Select value={form.program_id} onValueChange={(v) => setForm({ ...form, program_id: v })}>
                <SelectTrigger className="mt-1"><SelectValue placeholder="Select" /></SelectTrigger>
                <SelectContent>{refs.programs.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div>
              <Label>Type</Label>
              <Select value={form.type} onValueChange={(v) => setForm({ ...form, type: v })}>
                <SelectTrigger className="mt-1"><SelectValue /></SelectTrigger>
                <SelectContent>{TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1" /></div>
              <div><Label>SLA</Label><Input value={form.sla} onChange={(e) => setForm({ ...form, sla: e.target.value })} className="mt-1" placeholder="4 business hours" /></div>
            </div>
            <div><Label>Email</Label><Input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" /></div>
            <div><Label>Note</Label><Input value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} className="mt-1" /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={create} data-testid="escalation-form-save">Save</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
